module.exports = [
    '$resource',
    'Util',
function (
    $resource,
    Util
) {

    var TermsOfServiceEndpoint = $resource(Util.apiUrl('/tos/'), {

    }, {
        get: {
            method: 'GET'
        }
    });

    return TermsOfServiceEndpoint;
}];



// WEBPACK FOOTER //
// ./app/common/services/endpoints/terms-of-service-endpoint.js